import { useEffect, useRef, useState } from 'react';
import { useAuthContext } from '../../hooks/auth';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSpinner, faTrash } from '@fortawesome/free-solid-svg-icons';
import { Helmet } from 'react-helmet-async';
import style from './style.module.scss';
import { displayWarning } from "../../utils/messageToast";
import { toRespondTickets } from '../../functions/respondTickets';
import { InputsInfosPages } from '../../components/ui/inputs';
import { TextAreaErrors, TextAreaField } from '../../components/ui/textArea';

export default function Pendency() {
  const { authorizationRA, user, signOut } = useAuthContext();
  const ambient = user?.ambient as string;
  const [loadingButton, setLoadingButton] = useState(false);
  const [csvData, setCsvData] = useState<any[]>([]);
  const textAreaRef = useRef<HTMLTextAreaElement>(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [textAreaValue, setTextAreaValue] = useState<string>('');
  const [protocolData, setProtocolData] = useState<any[]>([]);
  const [pendency, setPendency] = useState<string>('');
  const [isErrors, setIsErrors] = useState(false);
  const [errors, setErrors] = useState<any[]>([]);

  const useIsomorphicEffect = useEffect;
  const [cacheCleared, setCacheCleared] = useState(false);

  useIsomorphicEffect(() => {
    const executeClearCache = async () => {
      await clearCacheClient();
    };
    executeClearCache();

  }, []);

  const clearCacheClient = async () => {
    try {
      const cacheKeys = await caches.keys();
      if (cacheKeys.length > 0) {
        await Promise.all(cacheKeys.map(key => caches.delete(key)));
        setCacheCleared(true);
      }
    } catch (error: any) {
      return error
    }
  };

  const handleTextAreaValue = async (value: string) => {
    const lines = value.split('\n').map(line => ({ protocol: line }));
    setProtocolData(lines);
  }

  const adjustHeight = () => {
    if (textAreaRef.current) {
      textAreaRef.current.style.height = 'auto';
      textAreaRef.current.style.height = `${textAreaRef.current.scrollHeight}px`;
    }
  };

  useEffect(() => {
    adjustHeight();
  }, [csvData]);

  const handlePendency = async () => {
    setLoadingButton(true);
    await new Promise((resolve) => setTimeout(resolve, 3000));
    const updatedProtocolData = protocolData.map(item => ({
      ...item,
      text: pendency,
    }));
    await toRespondTickets(ambient, authorizationRA, updatedProtocolData, setCsvData, setIsErrors, setErrors, signOut);
    setPendency('');
    setTextAreaValue('');
    setLoadingButton(false);
    setIsModalOpen(false);
  };

  return (
    <div>
      <Helmet>
        <title>Tech Forms - Responder Pendência em massa</title>
      </Helmet>

      <div className={style.container}>
        <div className={style.containerMain}>

          <div className={style.items}>

            <button
              className={style.buttonSend}
              onClick={async () => {
                if (!textAreaValue) {
                  displayWarning("Nenhum protocolo informado");
                  return;
                }
                setIsModalOpen(true)
              }}
            >
              {!loadingButton ? (
                <a>Responder</a>
              ) : (
                <FontAwesomeIcon icon={faSpinner} spin />
              )}
            </button>

            <button
              className={style.buttonClear}
              onClick={() => {
                setTextAreaValue('');
              }}
            >
              Limpar
            </button>

            <InputsInfosPages
              placeholder='Resposta da pendencia'
              type='text'
              value={pendency}
              style={{ width: '80%', height: '40px' }}
              onChange={(event: React.ChangeEvent<HTMLInputElement>) =>
                setPendency(event.target.value)
              }
            />
          </div>
        </div>

        <h1 style={{ color: '#fff' }} className={style.divTextArea}>Protocolos</h1>

        <TextAreaField
          value={textAreaValue}
          className={style.jsonTextarea}
          placeholder=""
          onChange={(e) => {
            setTextAreaValue(e.target.value);
            handleTextAreaValue(e.target.value);
          }}
        />

        {isErrors && (
          <>
            <h3 >Errors</h3>
            <TextAreaErrors
              value={errors}
              className={style.jsonTextareaErrors}
              readOnly
            />
          </>
        )}

        {isModalOpen && (
          <div className={style.modal}>
            <div className={style.modalContent}>
              <p>Confirma a tabulação em massa?</p>
              <div className={style.modalActions}>
                <button
                  className={style.modalButton}
                  onClick={handlePendency}
                  disabled={loadingButton}
                >
                  {loadingButton ? <FontAwesomeIcon icon={faSpinner} spin /> : 'Confirmar'}
                </button>
                <button
                  className={style.modalButton}
                  onClick={() => setIsModalOpen(false)} // Fecha o modal
                >
                  Cancelar
                </button>
              </div>
            </div>
          </div>
        )}

      </div>
    </div>
  );
}
